import {api} from '../api';
import http from '../http';
import axios from 'axios';
import {store} from '../../redux/store';
import {Platform} from 'react-native';
import {HttpResponse} from '../../interfaces/api/http';
import {
  CreatePatientBody,
  CreatePatientReportBody,
  FormItemType,
  GetFormResponse,
  GetPatientReportResponse,
  GetPatientReportsResponse,
  GetPatientResponse,
  GetPatientsResponse,
} from '../../interfaces/api/content/ehr';

export interface EhrDetailsResponse {
  patient_prompt?: string;
  created_at?: string;
  staff_id?: string;
}

export const ehr = {
  // Forms
  getListForms: (): Promise<HttpResponse<FormItemType[]>> =>
    new Promise((resolve, reject) => {
      http
        .get<FormItemType[]>(api.ehr.forms)
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),
  getForm: (id: number): Promise<HttpResponse<GetFormResponse>> =>
    new Promise((resolve, reject) => {
      const url = `${api.ehr.forms}/${id}`;
      http
        .get<GetFormResponse>(url)
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),

  // Patients
  getPatients: (page: number): Promise<HttpResponse<GetPatientsResponse>> =>
    new Promise((resolve, reject) => {
      const url = `${api.ehr.patients}?page=${page}&pageSize=20`;
      http
        .get<GetPatientsResponse>(url)
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),
  getPatient: (id: number): Promise<HttpResponse<GetPatientResponse>> =>
    new Promise((resolve, reject) => {
      const url = `${api.ehr.patients}/${id}`;
      http
        .get<GetPatientResponse>(url)
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),
  createPatient: (
    body: CreatePatientBody,
  ): Promise<HttpResponse<GetPatientResponse>> =>
    new Promise((resolve, reject) => {
      http
        .post<GetPatientResponse>(api.ehr.patients, body)
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),
  updatePatient: (
    id: number,
    body: CreatePatientBody,
  ): Promise<HttpResponse<GetPatientResponse>> =>
    new Promise((resolve, reject) => {
      const url = `${api.ehr.patients}/${id}`;
      http
        .post<GetPatientResponse>(url, body)
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),
  deletePatient: (id: number): Promise<HttpResponse<GetPatientResponse>> =>
    new Promise((resolve, reject) => {
      const url = `${api.ehr.patients}/delete/${id}`;
      http
        .post<GetPatientResponse>(url, {})
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),

  // Reports
  getPatientReports: (
    patentId: number,
    page: number,
  ): Promise<HttpResponse<GetPatientReportsResponse>> =>
    new Promise((resolve, reject) => {
      const url = `${api.ehr.patientReports}?page=${page}&patient_id=${patentId}&pageSize=20`;
      http
        .get<GetPatientReportsResponse>(url)
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),
  getPatientReport: (
    id: number,
  ): Promise<HttpResponse<GetPatientReportResponse>> =>
    new Promise((resolve, reject) => {
      const url = `${api.ehr.patientReports}/${id}`;
      http
        .get<GetPatientReportResponse>(url)
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),
  createPatientReport: (
    body: CreatePatientReportBody,
  ): Promise<HttpResponse<GetPatientReportResponse>> =>
    new Promise((resolve, reject) => {
      http
        .post<GetPatientReportResponse>(api.ehr.patientReports, body)
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),
  updatePatientReport: (
    id: number,
    body: CreatePatientReportBody,
  ): Promise<HttpResponse<GetPatientReportResponse>> =>
    new Promise((resolve, reject) => {
      const url = `${api.ehr.patientReports}/${id}`;
      http
        .post<GetPatientReportResponse>(url, body)
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),
  deletePatientReport: (
    id: number,
  ): Promise<HttpResponse<GetPatientReportResponse>> =>
    new Promise((resolve, reject) => {
      const url = `${api.ehr.patientReports}/delete/${id}`;
      http
        .post<GetPatientReportResponse>(url, {})
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),

  // EHR details by id/token (requires Authorization header)
  getEhrDetailsByIdToken: (
    id: string | number,
    token: string,
  ): Promise<HttpResponse<EhrDetailsResponse>> =>
    new Promise((resolve, reject) => {
      const url = `ehr-data/details?id=${id}&token=${token}`;
      http
        .get<EhrDetailsResponse>(url)
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),
};
